<script>
	import { slide } from 'svelte/transition'

	export let subMenu = ''
	export let parentLi = null
	export let setupColorLinks = null

	// let mount = node => node.appendChild(subMenu)

	let shown = ~subMenu.indexOf('current-menu-item')

	let setupLinksInterval

	if (parentLi) {
		parentLi.querySelector('a').addEventListener('click', e => {
			if (!shown) {
				e.preventDefault()
				shown = true
			}
		})
	}

	function runColorLinksInterval() {
		setupLinksInterval = setInterval(setupColorLinks, 50)
	}
	function stopColorLinksInterval() {
		clearInterval(setupLinksInterval)
	}
</script>

{#if shown}
	<div
		class="sub-menu-wrap"
		transition:slide
		on:introstart={runColorLinksInterval}
		on:introend={stopColorLinksInterval}
		on:outrostart={runColorLinksInterval}
		on:outroend={stopColorLinksInterval}>
		{@html subMenu}
	</div>
{/if}
